//@ts-nocheck
// src/tableManager.ts
import { getParquetFilesAsArrow } from './parquetLoader';
import { Table } from 'apache-arrow';
import { setLoadedCells } from './typesAndUtils';

const tableStore: Map<string, Table> = new Map();

export function setTables(tables: [string, Table][]) {
  tableStore.clear();
  for (const [name, table] of tables) {
    if (table && typeof name === 'string') {
      tableStore.set(name, table);
    } else {
      console.warn(`Invalid table or name: ${name}`);
    }
  }
  console.log(`Set ${tableStore.size} tables in tableManager`);
  console.log(tableStore);
}

export function getTable(name: string): Table | undefined {
  const table = tableStore.get(name);
  if (!table) {
    return undefined;
  }
  return table;
}

export async function loadAndStoreTables(
  companyFiles: string[],
  onLoading?: (isLoading: boolean, progress?: number, total?: number) => void
): Promise<void> {
  console.log('loadAndStoreTables: Starting with companyFiles:', companyFiles);
  console.log('loadAndStoreTables: onLoading callback present:', !!onLoading);
  onLoading?.(true, 0, companyFiles.length);
  try {
    console.log('loadAndStoreTables: Calling getParquetFilesAsArrow');
    const tables = await getParquetFilesAsArrow(companyFiles, (isLoading, progress, total) => {
      console.log('loadAndStoreTables: Received onLoading from getParquetFilesAsArrow:', { isLoading, progress, total });
      onLoading?.(isLoading, progress, total);
    });
    console.log('loadAndStoreTables: Received tables:', Object.keys(tables));
    const tableEntries = Object.entries(tables).map(([tableName, table]) => [tableName, table]);
    const uniqueCellIds = Array.from(new Set(tableEntries.map(([tableName]) => tableName.split('-')[0])));
    setLoadedCells(uniqueCellIds);
    setTables(tableEntries);
  } catch (error) {
    console.error('loadAndStoreTables: Error:', error);
    onLoading?.(false, 0, companyFiles.length);
    throw error;
  } finally {
    console.log('loadAndStoreTables: Finally, setting isLoading: false');
    onLoading?.(false, 0, companyFiles.length);
  }
}

export function getSingleFilteredTable(table: Table, sicLetters: string[]): Table | null {
  const slicedTables = sliceTableBySicLetter(table, sicLetters);
  const singleTable = Object.values(slicedTables).reduce((acc, _table) => acc.concat(_table));
  
  return singleTable;
}

export function getFilteredTables(table: Table, sicLetters: string[]): Record<string, Table | null> {
  const slicedTables = sliceTableBySicLetter(table, sicLetters);
  return slicedTables;
}

export function sliceTableBySicLetter(table: Table, sicLetters: string[]): Record<string, Table | null> {
  const offsets: Record<string, [number, number]> = {};
  let currentLetter: string | null = null;
  let startIdx = 0;

  const sicLetterColumn = table.getChild('sic_letter');
  if (!sicLetterColumn) {
    console.error('No sic_letter column found');
    return {};
  }

  for (let i = 0; i < sicLetterColumn.length; i++) {
    const letter = sicLetterColumn.get(i);
    if (letter !== currentLetter) {
      if (currentLetter) {
        offsets[currentLetter] = [startIdx, i];
        startIdx = i;
      }
      currentLetter = letter;
    }
  }
  if (currentLetter) {
    offsets[currentLetter] = [startIdx, sicLetterColumn.length];
  }

  const newSlicedTables: Record<string, Table | null> = {};
  sicLetters.forEach(letter => {
    const range = offsets[letter] || [0, 0];
    const [start, end] = range;
    newSlicedTables[letter] = end > start ? table.slice(start, end) : null;
  });

  return newSlicedTables;
}